import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../contexts/i18n';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './OTALogo.module.scss';

import { getId, getAriaHidden } from '@shared/utils-frontend/a11y';

type Props = {
  src: string;
  name: string;
  testId?: string;
  className?: string;
  index?: number;
  i18n: I18nService;
};

const cls = cssModules(STYLES);

const PARTNER_LOGIN_HEIGHT = 30;

const OTALogo = ({ className, i18n, index, name, src, testId }: Props) => {
  const altName = i18n.translate(
    'aria_partner',
    { partnerName: name },
    '{',
    '}',
  );

  return (
    <div
      className={cls('OTALogo', className)}
      id={getId('hotel_partner', index)}
      aria-hidden={getAriaHidden(index)}
    >
      <img
        src={src}
        alt={altName}
        height={PARTNER_LOGIN_HEIGHT}
        data-test-id={testId}
      />
    </div>
  );
};

export default withI18n(OTALogo);
